/* eslint-disable no-throw-literal */
import { Cusip, CusipResponse } from '../../types/api.types';
import { validateCusip } from '../../validation/schemas';

// NOTE:
// This service has been decoupled from the real backend.
// All CUSIP operations now work against an in-memory in-memory dataset.

const INVESCO_LOGO = 'https://cdn.govotr.com/logos/IVR.png';
const ISHARES_LOGO =
    'https://cdk-dev-cdn.govotr.com/issuer/New_Issuer_1788969146990/logo-1788969147721.png';

const INITIAL_CUSIPS: Cusip[] = [
    {
        cusip: '46090E103',
        description: 'Invesco QQQ Trust',
        ticker: 'QQQ',
        isin: 'US46090E1038',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46090A689',
        description: 'Invesco QQQ Income Advantage ETF',
        ticker: 'QQA',
        isin: 'US46090A6892',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46090A697',
        description: 'Invesco S&P 500 Equal Weight Income Advantage ETF',
        ticker: 'RSPA',
        isin: 'US46090A6975',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46090A879',
        description: 'Invesco Variable Rate Investment Grade ETF',
        ticker: 'VRIG',
        isin: 'US46090A8799',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138G888',
        description: 'Invesco Short Term Treasury ETF',
        ticker: 'TBLL',
        isin: 'US46138G8886',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46137V399',
        description: 'Invesco S&P 500 BuyWrite ETF',
        ticker: 'PBP',
        isin: 'US46137V3991',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46137V563',
        description: 'Invesco High Yield Equity Dividend Achievers ETF',
        ticker: 'PEY',
        isin: 'US46137V5637',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46137V621',
        description: 'Invesco Financial Preferred ETF',
        ticker: 'PGF',
        isin: 'US46137V6213',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E511',
        description: 'Invesco Preferred ETF',
        ticker: 'PGX',
        isin: 'US46138E5116',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E537',
        description: 'Invesco National AMT-Free Municipal Bond ETF',
        ticker: 'PZA',
        isin: 'US46138E5371',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E206',
        description: 'Invesco California AMT-Free Municipal Bond ETF',
        ticker: 'PWZ',
        isin: 'US46138E2063',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E354',
        description: 'Invesco S&P 500 Low Volatility ETF',
        ticker: 'SPLV',
        isin: 'US46138E3547',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E610',
        description: 'Invesco KBW High Dividend Yield Financial ETF',
        ticker: 'KBWD',
        isin: 'US46138E6109',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E594',
        description: 'Invesco KBW Premium Yield Equity REIT ETF',
        ticker: 'KBWY',
        isin: 'US46138E5945',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E719',
        description: 'Invesco Fundamental High Yield Corporate Bond ETF',
        ticker: 'PHB',
        isin: 'US46138E7196',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138G870',
        description: 'Invesco Variable Rate Preferred ETF',
        ticker: 'VRP',
        isin: 'US46138G8704',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E131',
        description: 'Invesco S&P SmallCap High Dividend Low Volatility ETF',
        ticker: 'XSHD',
        isin: 'US46138E1318',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '46138E404',
        description: 'Invesco CEF Income Composite ETF',
        ticker: 'PCEF',
        isin: 'US46138E4046',
        logoUrl: INVESCO_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '00214Q104',
        description: 'iShares Core S&P 500 ETF',
        ticker: 'IVV',
        isin: undefined,
        logoUrl: ISHARES_LOGO,
        createdAt: '2026-09-09T00:00:00.000Z',
        updatedAt: '2026-09-09T00:00:00.000Z',
    },
    {
        cusip: '037833100',
        description: 'Apple',
        createdAt: '2025-07-31T17:01:01.097Z',
        updatedAt: '2025-07-31T17:01:01.097Z',
        // Optional fields left undefined
        isin: undefined,
    },
    {
        cusip: '537833100',
        description: 'Samsung',
        createdAt: '2025-07-31T17:01:01.097Z',
        updatedAt: '2025-07-31T17:01:01.097Z',
        isin: undefined,
    },
    {
        cusip: '63160R101',
        description: 'Meta',
        createdAt: '2025-08-01T13:43:49.131Z',
        updatedAt: '2025-08-01T13:43:49.131Z',
        isin: undefined,
    },
    {
        cusip: '88160R101',
        description: 'Tesla',
        createdAt: '2025-08-01T13:43:49.131Z',
        updatedAt: '2025-08-01T13:43:49.131Z',
        isin: undefined,
    },
];

// Mutable in-memory store so that create/update/delete are reflected
const byIssuerName = (a: Cusip, b: Cusip) =>
    (a.description ?? '').localeCompare(b.description ?? '', undefined, { sensitivity: 'base' });

let cusipStore: Cusip[] = [...INITIAL_CUSIPS].sort(byIssuerName);

export class CusipService {

    protected validate(data: Partial<Cusip>) {
        if (data.cusip) {
            return validateCusip(data.cusip);
        }
        return { isValid: true, errors: [] };
    }

    async getAllCusips(search: string, page: number = 1, pageSize: number = 10): Promise<CusipResponse> {
        // Filter by search keyword (simple contains match on cusip or description)
        const keyword = search?.trim().toLowerCase();
        const filtered = keyword
            ? cusipStore.filter(
                  c =>
                      c.cusip.toLowerCase().includes(keyword) ||
                      (c.description || '').toLowerCase().includes(keyword)
              )
            : cusipStore;

        const total = filtered.length;
        const start = (page - 1) * pageSize;
        const end = start + pageSize;

        const pageItems = filtered.slice(start, end);

        return Promise.resolve({
            data: pageItems,
            total,
            page,
            pageSize,
        });
    }

    async getCusipById(cusip: string): Promise<Cusip> {
        const found = cusipStore.find(c => c.cusip === cusip);
        if (!found) {
            throw new Error('CUSIP not found');
        }
        return Promise.resolve({ ...found });
    }

    async createCusip(data: Omit<Cusip, 'createdAt' | 'updatedAt'>): Promise<Cusip> {
        const now = new Date().toISOString();
        const newCusip: Cusip = {
            ...data,
            createdAt: now,
            updatedAt: now,
        };

        // Add new CUSIP to the top of the list
        cusipStore = [newCusip, ...cusipStore];
        return Promise.resolve(newCusip);
    }

    async updateCusip(cusip: string, data: { description: string, isin: string }): Promise<Cusip> {
        const existingIndex = cusipStore.findIndex(c => c.cusip === cusip);
        const existing = existingIndex >= 0 ? cusipStore[existingIndex] : undefined;
        if (!existing) {
            throw new Error('CUSIP not found');
        }

        const updated: Cusip = {
            ...existing,
            description: data.description ?? existing.description,
            isin: data.isin ?? existing.isin,
            updatedAt: new Date().toISOString(),
        };

        // Persist the updated CUSIP in the in-memory store
        cusipStore = [
            ...cusipStore.slice(0, existingIndex),
            updated,
            ...cusipStore.slice(existingIndex + 1),
        ];
        return Promise.resolve(updated);
    }

    async deleteCusip(cusip: string): Promise<void> {
        cusipStore = cusipStore.filter(c => c.cusip !== cusip);
        return Promise.resolve();
    }

    async exportToCsv(): Promise<Blob> {
        // Generate a simple CSV from the static data
        const header = 'cusip,description,ticker,isin,createdAt,updatedAt';
        const rows = cusipStore.map(c =>
            [c.cusip, c.description ?? '', c.ticker ?? '', c.isin ?? '', c.createdAt, c.updatedAt]
                .map(value => `"${(value || '').replace(/"/g, '""')}"`)
                .join(',')
        );
        const csv = [header, ...rows].join('\n');
        return Promise.resolve(new Blob([csv], { type: 'text/csv' }));
    }

    async uploadCusips(file: File): Promise<void> {
        // Parse a CSV file on the client and merge rows into the in-memory store.
        // Expected header columns (case-insensitive):
        // - cusip (required)
        // - description (optional)
        // - isin or isisin (optional – supports the typo from the sample)
        return new Promise<void>((resolve, reject) => {
            const reader = new FileReader();

            reader.onerror = () => {
                reject(new Error('Failed to read CUSIP file'));
            };

            reader.onload = () => {
                try {
                    const result = reader.result;
                    const text =
                        typeof result === 'string'
                            ? result
                            : new TextDecoder().decode(result as ArrayBuffer);

                    const lines = text
                        .split(/\r?\n/)
                        .map(line => line.trim())
                        .filter(line => line.length > 0);

                    if (lines.length === 0) {
                        throw new Error('The uploaded file is empty');
                    }

                    const headerCols = lines[0]
                        .split(',')
                        .map(h => h.trim().toLowerCase());

                    const cusipIndex = headerCols.indexOf('cusip');
                    const descIndex = headerCols.indexOf('description');
                    const isinIndex =
                        headerCols.indexOf('isin') !== -1
                            ? headerCols.indexOf('isin')
                            : headerCols.indexOf('isisin'); // allow the sample header typo

                    if (cusipIndex === -1) {
                        throw new Error('CSV must contain a "cusip" column');
                    }

                    const newCusips: Cusip[] = [];
                    const now = new Date().toISOString();

                    for (let i = 1; i < lines.length; i++) {
                        const cols = lines[i].split(',');
                        const cusip = (cols[cusipIndex] || '').trim();
                        if (!cusip) continue;

                        const description =
                            descIndex >= 0 ? (cols[descIndex] || '').trim() : '';
                        const isin =
                            isinIndex >= 0 ? (cols[isinIndex] || '').trim() : '';

                        const existingIndex = cusipStore.findIndex(c => c.cusip === cusip);
                        const base: Cusip = {
                            cusip,
                            description: description || undefined,
                            isin: isin || undefined,
                            createdAt: now,
                            updatedAt: now,
                        };

                        if (existingIndex >= 0) {
                            // Update existing CUSIP
                            cusipStore[existingIndex] = {
                                ...cusipStore[existingIndex],
                                ...base,
                                createdAt: cusipStore[existingIndex].createdAt,
                                updatedAt: now,
                            };
                        } else {
                            newCusips.push(base);
                        }
                    }

                    if (newCusips.length > 0) {
                        // Add new items at the top, preserving their order from the file
                        cusipStore = [...newCusips, ...cusipStore];
                    }

                    resolve();
                } catch (error) {
                    reject(error);
                }
            };

            // For this mock implementation we only support CSV files
            reader.readAsText(file);
        });
    }

    async downloadTemplate(): Promise<Blob> {
        // Provide a minimal CSV template as a Blob
        const template = 'cusip,description,isin';
        return Promise.resolve(new Blob([template], { type: 'text/csv' }));
    }
}

export const cusipService = new CusipService(); 